import {
  LinearProgress,
  Card,
  CardContent,
  Typography,
  Grid,
  Tooltip,
  IconButton,
  Stack,
} from "@mui/material";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridPagination,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { JReports } from "../../../../../../app/slices/jomla/reportsSlice";
import DateRangepicker from "../../../../../../helpers/dateRangePicker";
import dayjs from "dayjs";
import { MdOutlineClear } from "react-icons/md";
import { SelectJItem } from "../../../../../../components/Selectors/jomla/SelectJItem";
import { SelectPos } from "../../../../../../components/Selectors/SelectPos";
import { JItems } from "../../../../../../app/slices/jomla/itemsSlice";
import { SelectJRep } from "../../../../../../components/Selectors/SelectJRep";

const AddedJItems = () => {
  const dispatch = useDispatch();

  const [search, setSearch] = useState({
    startDate: dayjs().format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
    j_item_id: null,
    j_rep_id: null,
    user_id: null,
  });

  const _AddedItems = useSelector((state) => state.jReports.addedJItems);
  const loading = useSelector((state) => state.jReports.loading);
  const reportTypes = useSelector((state) => state.jReports.reportTypes);
  const _JItems = useSelector((state) => state.JItems.JItemsList.data);
  const _PointOfSales = useSelector(
    (state) => state.pointOfsales.posesList.data
  );
  const user = useSelector((state) => state.user.jRepList.data);

  const columns = [
    {
      field: "index",
      headerName: "#",
      flex: 0.2,
    },
    {
      field: "j_item_name",
      headerName: "اسم المنتج",
      flex: 1,
    },
    {
      field: "j_item_code",
      headerName: "Code",
      flex: 0.5,
    },
    {
      field: "price",
      headerName: "السعر",
      flex: 1,
      renderCell: (params) => {
        return <Typography>{params.row.price?.toLocaleString()}</Typography>;
      },
    },
    {
      field: "total_discount",
      headerName: "الخصم الكلي",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography>{params.row.total_discount?.toLocaleString()}</Typography>
        );
      },
    },
    {
      field: "revenue",
      headerName: "الربح",
      flex: 1,
      renderCell: (params) => {
        return <Typography>{params.row.revenue?.toLocaleString()}</Typography>;
      },
    },
    {
      field: "count",
      headerName: "العدد",
      flex: 1,
    },
    {
      field: "j_order_no",
      headerName: "رقم القائمة",
      flex: 1,
    },
    {
      field: "created_at",
      headerName: "التاريخ",
      flex: 1,
      renderCell: (params) => {
        return (
          <Box>
            <Typography>
              {dayjs(params.row.created_at).format("YYYY-MM-DD")}
            </Typography>
            <Typography variant="caption">
              {dayjs(params.row.created_at).format("hh:mm a")}
            </Typography>
          </Box>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(
      JReports.addedJItems({
        start_date: search.startDate,
        end_date: search.endDate,
        j_item_id: search.j_item_id,
        j_rep_id: search.j_rep_id,
        user_id: search.pos_id,
      })
    );
  }, [dispatch, reportTypes, search]);

  useEffect(() => {
    dispatch(JItems.getAllList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarExport
        csvOptions={{
          fileName: "حركات البيع | نظام دجلة",
          utf8WithBom: true,
        }}
      />
    </GridToolbarContainer>
  );

  function CustomFooter() {
    return (
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography color="primary" sx={{ marginX: 2 }}>
          القيمة الكلية : {_AddedItems.total_amount?.toLocaleString()} (IQD)
        </Typography>
        <GridPagination />
      </Stack>
    );
  }

  return (
    <Card>
      <CardContent>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={3}>
            <DateRangepicker
              startDate={search.startDate}
              endDate={search.endDate}
              handleOnChange={(searchDate) => {
                const updatedFilter = {
                  from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                  to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                };
                if (
                  updatedFilter.from !== searchDate.startDate ||
                  updatedFilter.to !== searchDate.endDate
                ) {
                  setSearch({
                    ...search,
                    startDate: dayjs(searchDate[0].startDate).format(
                      "YYYY-MM-DD"
                    ),
                    endDate: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectJItem
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  j_item_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _JItems.filter((x) => x.id === search.j_item_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectJRep
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  j_rep_id: newValue ? newValue.id : null,
                });
              }}
              value={
                user.filter((user) => user.id === search.j_rep_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectPos
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  pos_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _PointOfSales?.filter((x) => x.id === search.pos_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={1}>
            <Tooltip title="الغاء الفلتر">
              <IconButton
                onClick={() => {
                  setSearch({
                    startDate: dayjs().format("YYYY-MM-01"),
                    endDate: dayjs().format("YYYY-MM-DD"),
                    j_item_id: null,
                    j_rep_id: null,
                    user_id: null,
                  });
                }}
              >
                <MdOutlineClear />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ height: "80vh", width: "100%" }}>
              <DataGrid
                rows={
                  _AddedItems.data?.map((x, index) => ({
                    ...x,
                    index: index + 1,
                  })) ?? []
                }
                loading={loading}
                columns={columns}
                components={{
                  LoadingOverlay: LinearProgress,
                  Toolbar: customToolbar,
                  Footer: CustomFooter,
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AddedJItems;
